export const PRACTICE_ID = 'practices';
export const CATEGORY_ID = 'categories';
export const OUTDOOR_ID = 'outdoorPractice';
export const EVENT_ID = 'event';
export const THEME_ID = 'themes';
export const CITY_ID = 'cities';
export const DISTRICT_ID = 'districts';
export const STRUCTURE_ID = 'structures';
export const ACCESSIBILITY_ID = 'accessibilities';
export const ROUTE_ID = 'routes';
export const LABEL_ID = 'labels';
export const LABEL_EXCLUDE_ID = 'labels_exclude';
export const DATE_FILTER = 'date-filter';
export const ORGANIZER_ID = 'organizer';
